// import { HeroSection, GlobeDemo, PostCard, ServicesCard, SkeletonLoader, Projects, OfficePic,  PartnerCard } from '@/components'
"use client"
import dynamic from 'next/dynamic';
import { SkeletonLoader } from "@/components"
import partner from '../../../public/partner.jpg'
const HeroSection = dynamic(() => import('@/components/HeroSection'));
const GlobeDemo = dynamic(() => import('@/components/Globe'));
const PostCard = dynamic(() => import('@/components/PostCard'));
const ServicesCard = dynamic(() => import('@/components/Services'));
const Projects = dynamic(() => import('@/components/ProjectCards'));
const OfficePic = dynamic(() => import('@/components/OfficePic'));
const PartnerCard = dynamic(() => import('@/components/PartnerCard'));
const ShowReview = dynamic(() => import('@/components/ReviewSection/ReviewShow'));
const FlipWords = dynamic(() => import('@/components/ui/flip-words'));
import { Suspense,  } from 'react';
import { cn } from '@/lib/utils';
import Image from 'next/image';

const HomeClientPage = () => {
  const service1 = 'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575830/webdev_eimzac.webp'
  const service2 = 'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575811/mobileApp_ctcq2c.webp'
  const service3 = 'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575804/business2_lg2v5k.webp'
  const service4 = 'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575830/UIUX_c8aece.webp'
  const service5 = 'https://res.cloudinary.com/dcwai4hwc/image/upload/v1732515253/ourservice_ejnkp3.webp'
  const CEO = 'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575804/CEO6_v2dd4x.webp'
  const ExecDirector = 'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575804/Director_rr01cr.webp'
  const Director = 'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575805/Director2_eytjsk.webp'
  const words = ["BackOffice Integration", "PowerBI", "Quick book", "Accounting Services","Oracle","Financial Solution","SAP BI/BW", "BAW", "SAP BW", " SAP FI/CO", "SAP ABAP", "dotnet", "MRI Software","Dynamic 365","ERP"];
 
  return (
    <Suspense fallback={<SkeletonLoader/>}>
      <HeroSection />
      <Projects />
      <GlobeDemo />
      <div id='services' className='section-shell'>
      <div className='heading-glow'>
      <h1
        className='section-heading relative z-10'>
        Premier Service Solutions
      </h1>
      </div>
      <span   className='relative z-10 grid grid-cols-1 sm:grid-cols-2 px-4 max-w-7xl mx-auto  md:grid-cols-3 py-16 md:py-24 lg:grid-cols-5 gap-6  justify-items-center'>
        <ServicesCard  title={"Web Development"} url={service1} />
        <ServicesCard title={"Mobile Application"} url={service2} />
        <ServicesCard otherTitle={"Other Services"}  title={<FlipWords words={words}/>}  url={service5} />
        <ServicesCard   title={`UI/UX DESIGN`} url={service4} />
        <ServicesCard title={`B P O`} url={service3} />
       
      </span>
      </div>
      <div className='section-shell'>
      <div className='heading-glow'>
      <h2 className='section-heading relative z-10'>
        CEO & Directors
      </h2>
      </div>
      <span className='relative z-10 grid grid-cols-1 max-w-7xl mx-auto text-white md:grid-cols-2 lg:grid-cols-3 h-full gap-8 py-16 md:py-20'>
         <PostCard imageUrl={CEO}  post={'CEO'} fullName={'Haris Yusuf'} /> 
        <PostCard imageUrl={ExecDirector} post={'The Founder & Executive Director '} fullName={'Nizamuddin Tai'} />
         <PostCard  imageUrl={Director} post={'Director'} fullName={'Hassan Yusuf'} /> 
      </span>
      </div>

        <div className='section-shell'>
        <div className='heading-glow'>
        <h3 className='section-heading relative z-10  pt-10'>
          Where Hustle Meets Flow 
        </h3>
        </div>
        <div className='relative z-10'>

        <OfficePic />
        </div>
        </div>
     
      <div className='section-shell'>
      <div className='heading-glow'>
      <h1 className='section-heading relative z-10 pt-10'>
         Reviews 
        </h1>
      </div>
        <div className='relative z-10'>
        <ShowReview/>
        </div>
      </div>
      <div className='section-shell'>
      <div className='heading-glow'>
      <h2 className='section-heading relative z-10 pt-10'>
         Trusted & Partner 
        </h2>
      </div>
      <span className='relative z-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 max-w-7xl lg:max-w-10xl mx-auto justify-items-center  h-full gap-8 py-16 md:py-20'>
        <div className="max-w-44 w-full h-full  sm:w-44">
            <div
               className={cn(
                 "card-premium cursor-pointer overflow-hidden flex-shrink-0 relative h-fit rounded-2xl mx-auto flex flex-col gap-2 p-2",
            
              )}
            >
              <div className="rounded-xl overflow-hidden bg-transparent">
              <Image
                    alt={"Best Software Solutions | Nubitsoft "}
                    className={cn("h-32   bg-[#1C53CD] w-full  object-contain ")}
                    width="100"
                    height="200"
                    // priority
                    src={"https://res.cloudinary.com/dcwai4hwc/image/upload/v1732088352/gt_mdhbtd.png"}
                    />
              </div>
              <div className="text content">
                
                <p className="font-normal text-sm w-full text-center text-slate-200 relative z-10 py-1">
                  {'Strategic Partner (USA)'}
                </p>
              </div>
            </div>
          </div>
      {/* <PartnerCard   message={'Strategic Partner (USA)'} imageUrl={"https://res.cloudinary.com/dcwai4hwc/image/upload/v1732088352/gt_mdhbtd.png"}/> */}
      <PartnerCard   message={'Strategic Partner (Bahrain)'} imageUrl={'https://res.cloudinary.com/dcwai4hwc/image/upload/v1732087011/nubitlink_twq4cm.png'}/>
      <PartnerCard   message={'Strategic Partner'} imageUrl={partner}/>
      <PartnerCard   imageUrl={'https://res.cloudinary.com/dcwai4hwc/image/upload/v1731671635/pseb_i5gbzn.jpg'}/>
      <PartnerCard   imageUrl={'https://res.cloudinary.com/dcwai4hwc/image/upload/v1731933703/pasha-logo_zjyaor.png'}/>
      <PartnerCard   imageUrl={'https://res.cloudinary.com/dcwai4hwc/image/upload/v1731671595/kcci_logo_wnsea9.png'}/>
      </span>
      </div>
      </Suspense>
  )
}

export default HomeClientPage